import { createAction } from 'utils/redux'

export const setHasSentImpression = () => createAction({
  type: 'SET_HAS_SENT_IMPRESSION'
})

export const removeTriggerableCampaignImpression = payload => createAction({
  type: 'REMOVE_TRIGGERABLE_CAMPAIGN_IMPRESSION',
  payload
})
